// extracted by mini-css-extract-plugin
export default {"droppable":"Pin_droppable__6m3Tf","middleButton":"Pin_middleButton__3m8cD","pinContainer":"Pin_pinContainer__oYB+k"};